import Activity from './Activity';
import Klass from './Klass';
import Lesson from './Lesson';
import { Model, Nullable } from './Model';
import { QuestionProgressSummary } from './question-progress/QuestionProgressSummary';
import { LessonBlockRef } from './ScheduledLesson';
import User from './User';

type KlassRef = Pick<Klass, 'id' | 'name'>;
type StudentRef = Pick<User, 'id' | 'firstName' | 'lastName'>;
type ActivityRef = Pick<Activity, 'id' | 'name'>;
type LessonRef = Pick<Lesson, 'id' | 'name'> & { order: Nullable<number> };
type LessonBlockRefShort = Pick<LessonBlockRef, 'id' | 'order'>;

export interface ActivityProgress extends Model {
  questionsProgress: QuestionProgressSummary[];
  activity: ActivityRef;
  lesson: Nullable<LessonRef>;
  lessonBlock: Nullable<LessonBlockRefShort>;
  startDate?: string;
  lastUpdate?: string;
  hasDone: boolean;
  grade?: number;
  hasGrade?: boolean;
  klass: Nullable<KlassRef>;
  student: Nullable<StudentRef>;
  correctionStatus: ActivityCorrectionStatusEnum;
  sentAt: Nullable<string>;
}

export enum ActivityCorrectionStatusEnum {
  NOT_SUBMITTED = 'NOT_SUBMITTED',
  PENDING = 'PENDING',
  CORRECTED = 'CORRECTED',
}
